module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs@2x-74fc6f946a6f067759f1078360d225bc.png";